import apiFetch from '../apiFetch'

export default function (idProducto, token) {
  return apiFetch({endPoint: `Producto/getProducto?idProducto=` + idProducto, method: 'GET', body: null, token: token})
}